import sortBy from 'lodash/sortBy';
import industryConfig from 'wwg-utilities/dist/config/industryConfig';
import careerFields from './careerFielts';
import formats from './formats';
import hours from './hours';
import programTypes from './programTypes';
import project from './project';
import requirements from './requirements';
const config = {
  skillup: [
    {
      label: 'Distance',
      paramLabel: 'distance',
      options: ['10 miles', '25 miles', '50 miles', '100 miles', '100+ miles'],
    },
    {
      label: 'Career',
      paramLabel: 'careers',
      options: [],
    },
    {
      label: 'Industry',
      paramLabel: 'careerFields',
      options: sortBy(careerFields).filter((cf) => cf != 'Other'),
    },
    {
      label: 'Format',
      paramLabel: 'formats',
      options: formats,
    },
    {
      label: 'Hours',
      paramLabel: 'hours',
      options: hours,
    },
    {
      label: 'Age',
      paramLabel: 'age',
      options: [],
    },
    {
      label: 'Work Style',
      paramLabel: 'style',
      options: [
        'Artistic',
        'Conventional',
        'Enterprising',
        'Investigative',
        'Realistic',
        'Social',
      ],
    },
  ],
  wherewego: [
    {
      label: 'Industry',
      paramLabel: 'careerFields',
      options: sortBy(industryConfig.wherewego.careerFields),
    },
    {
      label: 'Format',
      paramLabel: 'formats',
      options: formats,
    },
    {
      label: 'Hours',
      paramLabel: 'hours',
      options: hours,
    },
    {
      label: 'Age',
      paramLabel: 'age',
      options: [],
    },

    {
      label: 'Requirements',
      paramLabel: 'requirements',
      options: requirements,
    },

    {
      label: 'Type',
      paramLabel: 'programType',
      options: programTypes,
    },
  ],
};

const trainingFilterOptions = config[project];

export default trainingFilterOptions;
